import { LoadingBoxBase } from './LoadingBoxBase';
export class LoadingBoxVoid extends LoadingBoxBase {
    /** @override */ end() {
        // void
    }
    /** @override */ start() {
        // void
    }
}
